"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'statemine',
  assets: [{
    denom_units: [{
      denom: '130',
      exponent: 0
    }, {
      denom: 'usdt',
      exponent: 6
    }],
    base: '130',
    name: 'Statemine',
    display: 'usdt',
    symbol: 'USDT',
    coingecko_id: 'tether'
  }]
};
var _default = exports["default"] = info;